import { Box, CircularProgress, Typography } from "@mui/material";
import { DefaultBadge, StatusBadge } from "../../atoms/StatusBadge";
import { FilterOption, BaseFilters, BaseFilterOptions, EvaluationRun } from "../../models/types";
import { IColumnVisibility } from "../../molecules/ColumnVisibility";
import { TableTextWithEllipsis } from "../../molecules/TableTextWithEllipsis";
import { defaultDateDisplay } from "../UIHelper";

export const FILTER_OPTIONS: FilterOption<BaseFilters>[] = [
  { label: "Name", value: "name" },
  { label: "Evaluation", value: "evaluation_run_num" },
  { label: "Related Use Case", value: "related_use_case_name" },
  { label: "Methodology", value: "evaluation_methodology" },
  ...BaseFilterOptions,
];

export const evaluationRunColumnsVisibility = ({
  showRelatedUseCase = true,
}: {
  showRelatedUseCase?: boolean;
}): IColumnVisibility<EvaluationRun>[] => [
  {
    field: "name",
    headerName: "Name",
    visible: true,
    columnMinWidth: 400,
    renderer: (evaluationRun) => <TableTextWithEllipsis value={evaluationRun.name} />,
  },
  ...(showRelatedUseCase
    ? ([
        {
          field: "related_use_case",
          headerName: "Related Use Case",
          visible: true,
          columnMinWidth: 200,
          columnMaxWidth: 200,
          renderer: (evaluationRun) =>
            evaluationRun?.related_use_case ? (
              <DefaultBadge value={evaluationRun?.related_use_case_name?.name} />
            ) : (
              <></>
            ),
        },
      ] as IColumnVisibility<EvaluationRun>[])
    : []),
  {
    field: "evaluated_asset",
    headerName: "Evaluated Asset",
    visible: true,
    columnMinWidth: 200,
    columnMaxWidth: 200,
    renderer: (evaluationRun) =>
      evaluationRun?.evaluated_asset ? (
        <DefaultBadge value={evaluationRun?.evaluated_asset_name?.name} />
      ) : (
        <></>
      ),
  },
  {
    field: "evaluation_methodology",
    headerName: "Methodology",
    visible: true,
    columnMinWidth: 120,
    columnMaxWidth: 120,
    renderer: (evaluationRun) => {
      const icon =
        evaluationRun.evaluation_methodology === "Custom Test Run" ? "fairo-logo" : "compl-ai";
      return (
        <DefaultBadge icon={icon} value={evaluationRun.evaluation_methodology} padding="4px" />
      );
    },
  },
  {
    field: "created_on",
    headerName: "Evaluated On",
    visible: true,
    columnMinWidth: 120,
    columnMaxWidth: 120,
    renderer: (evaluationRun) => defaultDateDisplay(evaluationRun.created_on),
  },
  {
    field: "score",
    headerName: "Overall Score",
    visible: true,
    columnMaxWidth: 120,
    columnMinWidth: 120,
    renderer: (evaluationRun) => {
      const value = evaluationRun.score < 1 ? evaluationRun.score * 100 : evaluationRun.score;
      return (
        <Box display="flex" gap="6px" alignItems="center">
          <CircularProgress
            variant="determinate"
            color="success"
            thickness={7}
            size={20}
            value={value}
          />
          <Typography variant="body2">{value}</Typography>
        </Box>
      );
    },
  },
  {
    field: "status",
    headerName: "Status",
    visible: true,
    columnMaxWidth: 100,
    columnMinWidth: 100,
    renderer: (evaluationRun) => <StatusBadge status={evaluationRun.status as any} />,
  },
];
